import {
  BrandCaptionLowerThirdEntityRaw,
  BrandCaptionLowerThirdIsInUse
} from "@common/domain";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { createReducer, on, Action } from "@ngrx/store";
import { flatMap } from "lodash";
import { BrandActions, BrandCaptionLowerThirdActions } from "../actions";

export const BRAND_CAPTION_LOWER_THIRD_FEATURE_KEY = "brandCaptionLowerThird";

export interface BrandCaptionLowerThirdState
  extends EntityState<BrandCaptionLowerThirdEntityRaw> {}

export const brandCaptionLowerThirdAdapter: EntityAdapter<BrandCaptionLowerThirdEntityRaw> =
  createEntityAdapter<BrandCaptionLowerThirdEntityRaw>({
    selectId: (_) => _.id,
    sortComparer: (lhs, rhs) => rhs.id - lhs.id
  });

export const initialBrandCaptionLowerThirdState: BrandCaptionLowerThirdState =
  brandCaptionLowerThirdAdapter.getInitialState({});

const reducer = createReducer(
  initialBrandCaptionLowerThirdState,
  on(BrandActions.brandGetListSuccess, (state, { brands }) =>
    brandCaptionLowerThirdAdapter.addMany(
      flatMap(brands, (_) => _.value.captionLowerThirds),
      state
    )
  ),
  on(BrandActions.brandCreateSuccess, (state, { brand }) => {
    return brandCaptionLowerThirdAdapter.addMany(
      brand.value.captionLowerThirds,
      state
    );
  }),
  on(BrandActions.brandDeleteSuccess, (state, { brandId }) => {
    const captions = Object.values(state.entities).filter(
      (_) => _?.brandId === brandId
    );

    return brandCaptionLowerThirdAdapter.removeMany(
      captions.map((_) => _!.id),
      state
    );
  }),
  on(
    BrandCaptionLowerThirdActions.brandCaptionLowerThirdCreateSuccess,
    (state, { brandCaptionLowerThird }) =>
      brandCaptionLowerThirdAdapter.addOne(
        brandCaptionLowerThird.toJSON(),
        state
      )
  ),
  on(
    BrandCaptionLowerThirdActions.brandCaptionLowerThirdDeleteSuccess,
    (state, { brandCaptionLowerThird }) =>
      brandCaptionLowerThirdAdapter.removeOne(
        brandCaptionLowerThird.value.id,
        state
      )
  ),
  on(
    BrandCaptionLowerThirdActions.brandCaptionLowerThirdUnUseSuccess,
    (state, { brandCaptionLowerThird }) =>
      brandCaptionLowerThirdAdapter.updateOne(
        {
          id: brandCaptionLowerThird.value.id,
          changes: { isInUse: false as BrandCaptionLowerThirdIsInUse }
        },
        state
      )
  ),
  on(
    BrandCaptionLowerThirdActions.brandCaptionLowerThirdUpdateSuccess,
    (state, { brandCaptionLowerThird }) =>
      brandCaptionLowerThirdAdapter.updateOne(
        {
          id: brandCaptionLowerThird.value.id,
          changes: {
            caption: brandCaptionLowerThird.value.caption,
            dataUrl: brandCaptionLowerThird.value.dataUrl
          }
        },
        state
      )
  ),
  on(
    BrandCaptionLowerThirdActions.brandCaptionLowerThirdUseSuccess,
    (state, { brandCaptionLowerThird }) => {
      const captions = Object.values(state.entities).filter(
        (_) => _?.brandId === brandCaptionLowerThird.value.brandId
      );

      return brandCaptionLowerThirdAdapter.updateOne(
        {
          id: brandCaptionLowerThird.value.id,
          changes: { isInUse: true as BrandCaptionLowerThirdIsInUse }
        },
        brandCaptionLowerThirdAdapter.updateMany(
          captions.map((_) => ({
            id: _!.id,
            changes: { isInUse: false as BrandCaptionLowerThirdIsInUse }
          })),
          state
        )
      );
    }
  )
);

export function brandCaptionLowerThirdReducer(
  state: BrandCaptionLowerThirdState | undefined,
  action: Action
) {
  return reducer(state, action);
}
